import CellComponent from "@ext/markdown/elements/table/edit/components/CellComponent";
import TableCell from "@tiptap/extension-table-cell";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { tableCell } from "../tableSchema";

const CustomTableCell = TableCell.extend({
	addNodeView() {
		return ReactNodeViewRenderer(CellComponent, {
			as: "td",
			attrs: ({ HTMLAttributes }) => {
				const newAttrs: Record<string, string> = {};
				for (const [name, value] of Object.entries(HTMLAttributes)) {
					if (value !== undefined && value !== false && value !== "") newAttrs[name] = value;
				}
				return newAttrs;
			},
			stopEvent: () => false,
		});
	},
	parseHTML() {
		return [
			{
				tag: "td",
			},
			{
				tag: "th",
			},
		];
	},

	addAttributes() {
		return {
			...tableCell.attrs,
			aggregation: {
				default: null,
				parseHTML: (element) => element.getAttribute("aggregation") || null,
				renderHTML: (attributes) => ({ aggregation: attributes.aggregation ?? null }),
			},
			colwidth: {
				default: null,
				parseHTML: (element) => {
					const colwidth = element.getAttribute("colwidth");
					const value = colwidth ? colwidth.split(",").map((width) => parseInt(width, 10)) : null;

					return value;
				},
				renderHTML: (attributes) => {
					if (!attributes.colwidth) return {};
					return { colwidth: attributes.colwidth.join(",") };
				},
			},
		};
	},
});

export default CustomTableCell;
